import { apiDelete } from "../baseApi";

export const deleteById = async (id, cancelToken = null) => {
  try {
    const response = await apiDelete("_domain", id, {}, { cancelToken });
    return { ...response };
  } catch (error) {
    return Promise.reject(error);
  }
};
